import { Analytics } from '@segment/analytics-node';
import os from 'os';
import { v4 as uuidv4 } from 'uuid';
import getEnvironmentVariables from './getEnvironmentVariables';
import { currentUser } from './firestore';
import { getAuthConfig } from './configStore';
import getCliVersion from './getCliVersion';

const environmentVariables = getEnvironmentVariables();

let analytics: Analytics | undefined = new Analytics({
  flushAt: 1,
  flushInterval: 1,
  writeKey: environmentVariables.SEGMENT_KEY,
});

export const ANALYTICS_EVENT = {
  CLI_COMMAND: 'CLI Command',
};

export function disableAnalytics() {
  analytics = undefined;
}

function getAnalyticsBaseProperties() {
  const baseProps = {
    app: {
      cliVersion: '',
    },
    client: 'cli',
    user: {
      email: '',
    },
    os: {
      name: '',
      version: '',
    },
    runtime: {
      name: 'Node.js',
      version: '',
    },
  };
  try {
    baseProps.os = {
      name: os.platform(),
      version: os.release(),
    };
  } catch {
    // nothing
  }

  try {
    baseProps.user = {
      email: getAuthConfig().email as string,
    };
  } catch {
    // nothing
  }

  try {
    baseProps.app = {
      cliVersion: getCliVersion(),
    };
  } catch {
    // nothing
  }

  try {
    baseProps.runtime = {
      name: 'Node.js',
      version: process.version,
    };
  } catch {
    // nothing
  }

  return baseProps;
}

const anonymousId = uuidv4();
export const track = (event: string, properties = {}, callback = () => {}) => {
  try {
    const user = currentUser();
    analytics?.track(
      {
        event,
        userId: user?.uid,
        anonymousId,
        properties: {
          ...properties,
          ...getAnalyticsBaseProperties(),
        },
      },
      callback,
    );
  } catch {
    // nothing
  }
};

export const identify = (id: string, traits = {}, callback = () => {}) => {
  try {
    analytics?.identify({ userId: id, anonymousId, traits }, callback);
  } catch {
    // nothing
  }
};

export const flush = () => analytics?.flush({ close: true });
